import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnDestroy, OnInit, Output } from '@angular/core';
import { StringUtils } from 'app/com/ibm/tw/commons/utils/string.utils';
import { environment } from 'environments/environment';
import { Subscription } from 'rxjs';
import { NumericUtils } from '../../../../../com/ibm/tw/commons/utils/numeric.utils';
import { AxthenticationService } from '../../../../../services';
import { TxnService } from './../../../../../services/txn.service';
import { TimeoutPopupViewForm } from './timeout.popup.viewfrom';
import { CommandButtonModule } from 'ui-components/button';
import { EventData, StatusService } from 'ui-components/common';
import { MessagesModule } from 'ui-components/messages';
import { PopupModule } from 'ui-components/popup';

@Component({
    standalone: false,
    selector: 'timeout-popup',
    templateUrl: 'timeout.popup.component.html'
})
export class TimeoutPopupComponent implements OnInit, OnDestroy {

    @Input() display: boolean = false;

    @Input() viewForm: TimeoutPopupViewForm;

    @Output() closeCallback = new EventEmitter();

    @Output() confirmCallback = new EventEmitter();

    @Output() timerCallback = new EventEmitter();

    /** 已逾時分鐘 */
    minute: number;

    timerSubscription: Subscription;

    timer: any;

    timeout: string;

    constructor(
        private axthenticationService: AxthenticationService,
        private statusService: StatusService, public txnService: TxnService) {
    }

    ngOnInit() {
        this.timeout = this.formatToTime(this.statusService.currentTime);
        this.viewForm = new TimeoutPopupViewForm();
        this.startTimeoutTimer(null);

        if (StringUtils.isEmptyStr(this.viewForm.title)) {
            this.viewForm.title = this.txnService.transform('登出系統', 'chm00001051', null);
        }

    }
    onClose(event: EventData) {
        this.closeCallback.emit();
    }

    onShow() {
    }

    onHide(event: EventData) {

        this.closeCallback.emit();
        if (this.display) {
            this.display = false;
            this.axthenticationService.resetTimer();
        }

    }

    doConfirm(event: EventData): void {
        this.confirmCallback.emit(true);
        clearInterval(this.timer);
        this.axthenticationService.logout();
    }


    /** 啟始Timer */
    startTimeoutTimer(event: EventData): void {

        // 先將之前的timer關閉
        clearInterval(this.timer);

        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }

        this.axthenticationService.resetTimer();

        if (!environment.isDemo) {
            this.timer = setInterval(() => {
                this.statusService.resetTimer(this.statusService.currentTime - 1);
            }, 1000);
        }

        this.timerSubscription = this.statusService.timerSource$.subscribe(
            timetimeNum => {

                let now = new Date();

                let nowDateTime: number = now.getTime();

                this.statusService.currentTime = NumericUtils.round((this.statusService.willTimeout - nowDateTime) / 1000, 0);

                // console.log('timeout=' + this.statusService.currentTime);

                this.timeout = this.formatToTime(this.statusService.currentTime);

                let eventData: EventData = new EventData(null, this.timeout, true, null)

                this.timerCallback.emit(eventData);

                this.viewForm.timeout = this.statusService.currentTime;

                // console.log(' this.viewForm.timeout .....' + this.viewForm.timeout + ',' + this.statusService.currentTime);

                if (this.statusService.currentTime <= 0) {
                    clearInterval(this.timer);
                    // 將目前人員進行登出
                    this.axthenticationService.logout();
                } else if (this.statusService.currentTime <= 60) { // 4分鐘 : 4*60

                    let countTime = 0;
                    if (this.axthenticationService.timeoutSecond > 0) {
                        // console.log('task timeout:' + this.axthenticationService.timeoutSecond);
                        countTime = this.axthenticationService.timeoutSecond;
                    } else {
                        // console.log('default task timeout:' + this.axthenticationService.defaultTimeoutSecond);
                        countTime = this.axthenticationService.defaultTimeoutSecond;
                    }

                    // console.log('countTime..' + countTime);

                    this.minute = NumericUtils.round((countTime - 60) / 60, 0);

                    // console.log('minute..' + this.minute);
                    if (this.txnService.getShareService().alreadyTimeoutPopup === false) {
                        this.txnService.getShareService().alreadyTimeoutPopup = true;
                        this.display = true;
                    }

                }
            });
    }


    formatToTime(currentTime: number): string {
        let second: number = Number(this.statusService.currentTime) % 60;
        second = NumericUtils.round(second, 0);
        // NumericUtils.round(
        return this.formatNumber(Math.floor(Number(this.statusService.currentTime) / 60)) + ':' +
            this.formatNumber(second);
    }

    formatNumber(num: number): string {
        if (num < 10) {
            return '0' + String(num);
        } else {
            return String(num);
        }
    }

    ngOnDestroy() {
        // prevent memory leak when component destroyed
        clearInterval(this.timer);
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }
}
@NgModule({
    imports: [
        CommonModule,
        PopupModule,
        CommandButtonModule,
        MessagesModule
    ],
    declarations: [TimeoutPopupComponent],
    exports: [TimeoutPopupComponent]
})
export class TimeoutPopupModule {
}
